const postVendors = {
  PREMIER: 'Premier',
  MEYER: 'Meyer',
  KEYSTONE: 'Keystone',
  TURN14: 'Turn14',
  COMPS: 'Comps',
  ROCKAUTO: 'RockAuto',
  ATECH: 'Atech',
  MOTORSTATE: 'Motorstate',
  ETRISTATE: 'Etristate',
  CO_WAREHOUSE: 'CO Warehouse',
  TOYTEC: 'ToyTec',
  RCD: 'RCD',
  BROSCONE: 'broscone',
  MOTOVICITY: 'Motovicity',
  METAL_TECH: 'Metal Tech',
  NISSTEC: 'Nisstec',
  SOCAL: 'SoCal',
  COLO: 'Colo',
  EBAY: 'eBay',
  AIRBAGIT: 'AirBagIt',
  FIND_IT_PARTS: 'FindItParts.com',
  REPAIR_LINK_SHOP: 'RepairLinkShop',
  OTHER: 'Other',
  CUSTOM: 'Custom Vendor',
};
export const postVendorsList = [
  { label: postVendors.PREMIER, value: postVendors.PREMIER },
  { label: postVendors.MEYER, value: postVendors.MEYER },
  { label: postVendors.KEYSTONE, value: postVendors.KEYSTONE },
  { label: postVendors.TURN14, value: postVendors.TURN14 },
  { label: postVendors.COMPS, value: postVendors.COMPS },
  { label: postVendors.ROCKAUTO, value: postVendors.ROCKAUTO },
  { label: postVendors.ATECH, value: postVendors.ATECH },
  { label: postVendors.MOTORSTATE, value: postVendors.MOTORSTATE },
  { label: postVendors.ETRISTATE, value: postVendors.ETRISTATE },
  { label: postVendors.CO_WAREHOUSE, value: postVendors.CO_WAREHOUSE },
  { label: postVendors.TOYTEC, value: postVendors.TOYTEC },
  { label: postVendors.RCD, value: postVendors.RCD },
  { label: postVendors.BROSCONE, value: postVendors.BROSCONE },
  { label: postVendors.MOTOVICITY, value: postVendors.MOTOVICITY },
  { label: postVendors.METAL_TECH, value: postVendors.METAL_TECH },
  { label: postVendors.NISSTEC, value: postVendors.NISSTEC },
  { label: postVendors.SOCAL, value: postVendors.SOCAL },
  { label: postVendors.COLO, value: postVendors.COLO },
  { label: postVendors.EBAY, value: postVendors.EBAY },
  { label: postVendors.AIRBAGIT, value: postVendors.AIRBAGIT },
  { label: postVendors.FIND_IT_PARTS, value: postVendors.FIND_IT_PARTS },
  { label: postVendors.REPAIR_LINK_SHOP, value: postVendors.REPAIR_LINK_SHOP },
  { label: postVendors.OTHER, value: postVendors.OTHER },
  { label: postVendors.CUSTOM, value: postVendors.CUSTOM },
];
export default postVendors;
